export const getOrder = async () => {
  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "/bookings/" + localStorage.getItem("tp_order_id")
    );

    if (response.status === 404) {
      throw new Error("Order not found");
    }
    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response text:", errorText);
      throw new Error("Network response was not ok");
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      const errorText = await response.text();
      console.error("Error: Expected JSON but received:", errorText);
      throw new Error("Received non-JSON response");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export const getOrderFromPendingPaymentId = async (paymentId) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "/payments/" + paymentId
    );

    if (response.status === 404) {
      throw new Error("Order not found");
    }
    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response text:", errorText);
      throw new Error("Network response was not ok");
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      const errorText = await response.text();
      console.error("Error: Expected JSON but received:", errorText);
      throw new Error("Received non-JSON response");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

export const getOrderFromPaymentId = async (paymentId) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "/bookings/payment/" + paymentId
    );

    if (response.status === 404) {
      throw new Error("Order not found");
    }
    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response text:", errorText);
      throw new Error("Network response was not ok");
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      const errorText = await response.text();
      console.error("Error: Expected JSON but received:", errorText);
      throw new Error("Received non-JSON response");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

export const postOrder = async (quotation_id, selectedDate, selectedOption = "") => {
  const body = {
    quotation_id: quotation_id,
  }

  if (selectedDate) {
    body.selected_date = selectedDate;
  }

  if(selectedOption){
    body.selected_option = selectedOption
  }

  if (window.localStorage.getItem("tp_order_id")) {
    body.tp_order_id = window.localStorage.getItem("tp_order_id");
  }

  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "/bookings/create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    );

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {

      const responseJson = await response.json();
      if (!response.ok) {
        // we're returning feedback to the user, as the only possible error is that the quotation is out of stock
        console.error("Error response message:", responseJson.message);
        throw new Error(responseJson.message);
      }

      const { order_id } = responseJson;
      return window.localStorage.setItem("tp_order_id", order_id)
    } else {
      const errorText = await response.text();
      console.error("Error: Expected JSON but received:", errorText);
      throw new Error("Received non-JSON response");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export const postPassengers = async (passengers, orderId) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "/passengers/" + orderId + "/change",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(passengers),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response text:", errorText);
      throw new Error("Network response was not ok");
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      const errorText = await response.text();
      console.error("Error: Expected JSON but received:", errorText);
      throw new Error("Received non-JSON response");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export const postCustomer = async (customer, orderId) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "/customers/" + orderId + "/change",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(customer),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response text:", errorText);
      throw new Error("Network response was not ok");
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      const errorText = await response.text();
      console.error("Error: Expected JSON but received:", errorText);
      throw new Error("Received non-JSON response");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export const postCreateTransaction = async (paymentId, paymentProvider) => {
  // We'll eventually load these directly from the server
  const PAYMENT_PROVIDERS = {
    transfer: {
      url: "/offline-payments/create-transaction"
    },
    cash: {
      url: "/offline-payments/create-transaction"
    },
    bank: {
      url: "/offline-payments/create-transaction"
    }
  }

  if (!PAYMENT_PROVIDERS[paymentProvider]) {
    throw new Error ("Payment provider not found.")
  }

  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + PAYMENT_PROVIDERS[paymentProvider].url,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ payment_public_id: paymentId, payment_provider_code: paymentProvider}),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response text:", errorText);
      throw new Error("Network response was not ok");
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      const errorText = await response.text();
      console.error("Error: Expected JSON but received:", errorText);
      throw new Error("Received non-JSON response");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};
